import React from "react";
import "../../../styles/utils/loading/ListLoading.scss";
import { SyncLoader } from "react-spinners";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function ListLoading() {
  const { t } = useAppTranslation("components/utils/listLoading");

  return (
    <div className="loading-overlay">
      <figure>
        <img src="/images/utils/loading/nikiariel.svg" alt={t("imageAlt")} />
      </figure>
      <div className="spinner">
        {t("message")}
        <SyncLoader size={3} />
      </div>
    </div>
  );
}
